<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_ORDER_VIEW')">
      <div class="row order-list">
        <div class="col-lg-12">
          <!-- start -->
          <div class="row">
            <div class="col-md-12">
              <div class="box-search d-flex">
                <el-input class="mr-2" placeholder="Tìm kiếm..." v-model="search.textSearch" @keydown.enter.native="searchItem" clearable>
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button class="mr-2 n-btn" type="primary"  @click="searchItem">Tìm kiếm</el-button>
                <el-popover placement="bottom-end" width="530" trigger="click" v-model="showFilter">
                  <!-- btn -->
                  <el-button class="n-btn" type="info" slot="reference">
                    <div class="n-icon">
                      <i class="mdi mdi-filter-outline"></i>
                      Bộ lọc
                    </div>
                  </el-button>
                  <!-- slot -->
                  <div class="row d-flex align-items-center mb-3">
                    <div class="col-3 text-right">Thời gian:</div>
                    <div class="col-9">
                      <el-date-picker class="w-100" type="daterange" align="right" start-placeholder="Từ ngày" end-placeholder="Đến ngày" format="dd/MM/yyyy" v-model="updatedAtRange"> </el-date-picker>
                    </div>
                  </div>

                  <div class="row d-flex align-items-center mb-3">
                    <div class="col-3 text-right">Kênh bán:</div>
                    <div class="col-9">
                      <el-select class="w-100" v-model="saleChannel" placeholder="Tất cả">
                        <el-option v-for="item in optionsSaleChannel" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                      </el-select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                      <el-button class="n-btn" @click="showFilter = false">Hủy</el-button>
                      <el-button class="n-btn" type="danger" plain @click="resetFilter">Xóa bộ lọc</el-button>
                      <el-button class="n-btn" type="primary" @click="searchItem">Áp dụng bộ lọc</el-button>
                    </div>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
          <div class="table-responsive mb-0">
            <b-table sticky-header="600px" :items="dataItem" :fields="fields" :key="updateUI" show-empty @row-clicked="clickRowItem" class="order-return-table n-table">
              <template #cell(orderNo)="data">
                <div class="text-primary">{{ data.item.orderNo }}</div>
              </template>
              <template #cell(total)="data">
                <div>{{ formatMoney(divisionThousand(data.item.total)) }}</div>
              </template>
              <template #cell(updatedAt)="data">
                <div>{{ timeFormatStatus(data.item.updatedAt) }}</div>
              </template>
            </b-table>
          </div>
          <div class="row mt-3 justify-content-center" v-show="isReturnOutDate">
            <div class="col-10">
              <b-alert class="custom-alert" id="refIdReturnOutDate" show variant="warning text-dark  ">
                Cửa hàng đã cấu hình thời gian đổi trả hàng trong vòng <b>{{ merchantReturn.returnTimeLimit + " " + getReturnTimeUnit[merchantReturn.returnTimeUnit] }}</b> tính từ ngày mua hàng thành công.<br />
                Để cài đặt lại, vui lòng đi tới <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
              </b-alert>
            </div>
          </div>

          <div class="DebtAccomplish-body-pagination m-0">
            <b-pagination v-model="currentPage" :total-rows="totalElements" :per-page="search.pageSize" aria-controls="debt-table" hide-goto-end-buttons limit="5" last-text="next" align="right" />
          </div>

          <div class="row justify-content-end mt-2">
            <div class="col-auto">
              <el-button class="n-btn" @click="$emit('closeModal')">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="box-loading" v-if="loading">
        <div class="loading">
          <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<script>
import { SettingService } from "@/services/nextshop/setting.service";
import { OrdersService } from "@/services/nextshop/orders.service";
import VueCookies from "vue-cookies";
import moment from "moment";

export default {
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      locationId: VueCookies.get("LID"),
      updateUI: 1,
      dataItem: [],
      loading: false,

      fields: [
        {
          key: "orderNo",
          label: "Mã đơn hàng",
          thStyle: { width: "3%" },
        },
        {
          key: "updatedAt",
          label: "Thời gian",
          thStyle: { width: "3%" },
        },
        {
          key: "customer",
          label: "Khách hàng",
          thStyle: { width: "3%" },
        },
        {
          key: "seller",
          label: "Nhân viên",
          thStyle: { width: "3%" },
        },
        {
          key: "total",
          label: "Tổng tiền",
          thStyle: { width: "3%" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],

      updatedAtRange: "",
      saleChannel: "",
      optionsSaleChannel: [
        {
          text: "Tất cả",
          value: "",
        },
        {
          text: "Bán tại cửa hàng",
          value: "NEXT_SHOP_POS_WEB_ENABLE_DRAFT",
        },
        {
          text: "Gian hàng trực tuyến",
          value: "ONLINE_STORE",
        },
      ],

      currentPage: 1,
      totalElements: 0,

      // search
      showFilter: false,
      textSearch: "",
      search: {
        queryString: "",
        sort: "DESC",
        sortBy: "id",
        pageSize: 10,
        pageNum: 1,
        textSearch: "",
        isOnlyReturnable: true,
      },
      searchTmp: [],

      // check out date
      isReturnOutDate: false,
      idReturnOutDate: "",
      merchantReturn: {},
      getReturnTimeUnit: {
        DAYS: "Ngày",
        WEEKS: "Tuần",
        MONTHS: "Tháng",
        YEARS: "Năm",
      },
    };
  },
  created() {
    this.fetchData();
    this.getMainApiMerchantReturn();
  },
  methods: {
    async getMainApiMerchantReturn() {
      try {
        const response = await SettingService.mainApiMerchant();
        if (response.success) {
          const temp = {};
          temp.enableLimitReturnTime = response.data.enableLimitReturnTime;
          temp.returnTimeLimit = response.data.returnTimeLimit;
          temp.returnTimeUnit = response.data.returnTimeUnit;
          this.merchantReturn = temp;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        await this.getParams();
        const response = await OrdersService.getListItemV2(this.search);
        this.dataItem = [];
        if (response.success) {
          if (response.data.data.length > 0) {
            const datas = [];
            response.data.data.map((e) => {
              const body = {
                id: e.id,
                // date: "",
                orderNo: e.orderNo,
                total: e.lineItemFinalizing && e.lineItemFinalizing.finalAmount ? e.lineItemFinalizing.finalAmount : 0,
                customer: e.partyB.displayName ? e.partyB.displayName : "",
                seller: e.partyA.displayName ? e.partyA.displayName : "",
                updatedAt: e.updatedAt,
              };
              datas.push(body);
            });

            this.dataItem = datas;
            // console.log("data", response.data.data);
            this.totalElements = response.data.totalElements;
          }
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },

    async getParams() {
      this.searchTmp = [];
      this.searchTmp.push("{locationToCreate} == '''" + this.locationId + "'''");
      this.searchTmp.push("{orderStatus} == '''SUCCESS'''");

      if (this.saleChannel) {
        this.searchTmp.push(`({targetMethod} == '''${this.saleChannel}''')`);
      }

      if (this.updatedAtRange) {
        this.searchTmp.push("{updatedAt} >= #" + `${moment(this.updatedAtRange[0]).format("YYYY-MM-DD")}` + `T00:00:00.000Z# and {updatedAt} <= #` + `${moment(this.updatedAtRange[1]).format("YYYY-MM-DD")}` + "T23:59:59.000Z#");
      }

      if (this.searchTmp.length) {
        this.search.queryString = this.searchTmp.join(" and ") + " and {orderType} == '''SO'''";
      }
    },
    searchItem() {
      // console.log("seẢCH");
      this.showFilter = false;
      this.search.pageNum = 1;
      this.currentPage = 1;
      this.fetchData();
    },
    resetFilter() {
      this.currentPage = 1;
      this.search = {
        queryString: "",
        sort: "DESC",
        sortBy: "id",
        pageSize: 10,
        pageNum: 1,
      };
      this.updatedAtRange = "";
      this.saleChannel = "";

      this.fetchData();
    },
    clickRowItem(item) {
      // console.log("returna able", this.checkIsReturn(item.updatedAt));
      // return
      if (!this.checkIsReturn(item.updatedAt)) {
        this.showNotifyNotReturn();
        return;
      }
      // console.log("ok");
      // return
      this.$router.push(`/orders-return/create/${item.id}`);
    },
    checkIsReturn(timeUpdate) {
      if (this.merchantReturn.enableLimitReturnTime) {
        const timeOrder = moment(timeUpdate);
        const timeOutDate = moment().subtract(this.merchantReturn.returnTimeLimit, this.merchantReturn.returnTimeUnit);
        const timestand = timeOrder - timeOutDate;
        if (timestand > 0) return true;
        return false;
      } else {
        return true;
      }
    },
    showNotifyNotReturn() {
      clearTimeout(this.idReturnOutDate);
      this.isReturnOutDate = true;
      setTimeout(() => {
        let messageElemnt = this.$el.querySelector("#refIdReturnOutDate");
        messageElemnt.scrollIntoView({ behavior: "smooth" });
      }, 50);

      this.idReturnOutDate = setTimeout(() => {
        this.isReturnOutDate = false;
      }, 10000);
    },
  },
  watch: {
    currentPage() {
      this.search.pageNum = this.currentPage;
      this.fetchData();
    },
    "search.textSearch"(val) {
      if (val == "") this.searchItem();
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-alert {
  border-color: #ffc043;
  background-color: #fff9ec;
}
</style>

<style lang="scss">
.order-list {
  .table td {
    height: 68px;
  }
  // .b-table-sticky-header {
  //   max-height: 400px;
  // }
}

.order-return-table {
  cursor: pointer;
}
</style>
